export const TAB = 'Tab';
export const ESCAPE = 'Escape';
export const ESC = 'Esc';
export const ARROWUP = 'ArrowUp';
export const UP = 'Up';
export const ARROWDOWN = 'ArrowDown';
export const DOWN = 'Down';
export const ENTER = 'Enter';
export const SPACE = 'Space';
export const SPACEBAR = 'Space Bar';
export const EMPTYSPACE = ' ';
